import React from 'react';
import { ComponentProps, WEIGHT } from './Btn.types';
import StyledButton from './Btn.styled';

const Button: React.FC<ComponentProps> = ({
  small,
  appearance,
  mode,
  borderVariant = 'rounded',
  weight = 'bold',
  ...props
}) => {
  const borderVariantMap = new Map([
    ['rounded', 25],
    ['rectangle', 1],
  ]);

  const weightMap = new Map([
    [WEIGHT.THIN.toString(), 260],
    [WEIGHT.LIGHT.toString(), 300],
    [WEIGHT.NORMAL.toString(), 400],
    [WEIGHT.MEDIUM.toString(), 500],
    [WEIGHT.SEMIBOLD.toString(), 600],
    [WEIGHT.BOLD.toString(), 700],
  ]);

  return (
    <StyledButton
      {...props}
      px={5}
      py={small ? 2 : 4}
      fontSize={4}
      mode={mode}
      borderRadius={borderVariantMap.get(borderVariant)}
      fontWeight={weightMap.get(weight)}
    />
  );
};

export default Button;
